import ReactDOM from 'react-dom/client';
import {
  applyRuntimeSideEffects,
  applyShellStyles,
  mountApplicationRoot,
  // registerProductionServiceWorker,
} from './bootstrap/shell-init';

applyShellStyles();

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found. Ensure index.html has <div id="root"></div>.');
}

const root = ReactDOM.createRoot(rootEl);

(function detectMacOS() {
  const isMacOS =
    /Mac|iPhone|iPad|iPod/.test(navigator.platform) ||
    /Mac OS X|Macintosh/.test(navigator.userAgent);
  if (isMacOS) {
    document.body.classList.add('macos');
  }
})();

mountApplicationRoot(root);

if (
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  process.env.NODE_ENV !== 'production' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
  });
}

// registerProductionServiceWorker();
applyRuntimeSideEffects();
